import { Button, Table, Layout, Flex, Modal, message } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { setTokens } from "../features/auth/authSlice";
import {
  DeleteTwoTone,
  EditTwoTone,
  EyeTwoTone,
  PlusOutlined,
} from "@ant-design/icons";
import {
  useGetAllEmailTemplateFoldersQuery,
  useLazyGetSiteInfoQuery,
  useDeleteEmailTemplateFolderMutation,
} from "../features/mailer/mailerApiSlice";
import moment from "moment/moment";
import LoadingComponentAntD from "../components/loadingCompAntd/LoadingComponentAntD";
import { setSiteInfor } from "../store/slice/siteInfoSlice";
import { Input } from "antd";

const { Content } = Layout;
const { Search } = Input;

function AllEmailTemplateFolders() {
  const [getSiteInfo] = useLazyGetSiteInfoQuery();
  const dispatch = useDispatch();
  const [headersReady, setHeadersReady] = useState(false);
  const { user_token, auth, viewType } = useParams();
  const navigate = useNavigate();
  const storeAuth = useSelector((state) => state.auth);
  const [messageApi, contextHolder] = message.useMessage();
  const [dataList, setDataList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [moduleName, setModuleName] = useState(null);
  const storeBaseUrl = useSelector((state) => state.baseUrl);
  const [search, setSearch] = useState("");

  const [deleteEmailTemplateFolder] = useDeleteEmailTemplateFolderMutation();

  const successMsg = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const errorMsg = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const { data, error } = useGetAllEmailTemplateFoldersQuery(undefined, {
    skip: !headersReady,
  });
  const [loading, setLoading] = useState(true);

  const onChange = (value, _e, info) => setSearch(value.target.value);

  const navigateToUpdate = (id) => {
    navigate(`/${auth}/${user_token}/${viewType}/edit-folder/${id}`);
  };

  useEffect(() => {
    if (storeAuth?.authBearer && storeAuth?.token) {
      setHeadersReady(true);
    }
  }, [storeAuth, storeBaseUrl.value]);

  useEffect(() => {
    if (user_token && auth && viewType) {
      dispatch(
        setTokens({
          user: null,
          token: user_token,
          auth,
          viewType,
        })
      );
    }
  }, [user_token, auth, viewType]);

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const { data, error } = await getSiteInfo();
        if (data) {
          dispatch(setSiteInfor(data));
        }
        if (error) {
          console.log("site-data::", error);
        }
      } catch (error) {}
    };

    if (!headersReady) {
      fetchSiteInfo();
    }
  }, [getSiteInfo, storeAuth, headersReady]);

  useEffect(() => {
    if (user_token && auth) {
      const fetchAllTemps = async () => {
        try {
          if (data) {
            if (data?.status) {
              const newData = data.folders.map((template, index) => ({
                ...template,
                serial: index + 1,
                created_at: moment(template.created_at).format("ll"),
                key: template.id,
              }));
              setDataList(newData);
              setFilterList(newData);
              setModuleName(data?.module_name);
              setTimeout(() => {
                setLoading(false);
              }, 3000);
              setLoading(false);
            }
            if (!data?.status) {
              console.log("!data.status");
              if (data?.message) {
                errorMsg(data?.message);
              }
            }
          }
          if (error) {
            console.log("error::", error);
          }
        } catch (error) {
          console.log("catch-error::", error);
        } finally {
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        }
      };
      fetchAllTemps();
    }
  }, [data, error]);

  const start = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    start();
  }, []);

  const columns = [
    {
      title: "Sr#",
      dataIndex: "serial",
      key: "serial",
      width: "22%",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text, record) => (
        <Flex gap="middle" vertical>
          <Flex wrap gap="middle" justify="left">
            <Button
              type="link"
              onClick={() => loadFolderTemplates(record.name)}
            >
              {record.name}
            </Button>
          </Flex>
        </Flex>
      ),
    },
    {
      title: "Templates",
      dataIndex: "templates_count",
      key: "templates",
      align: "left",
      render: (text, record) => (
        <Flex gap="middle" vertical>
          <Flex wrap gap="middle" justify="left">
            <Button
              type="link"
              onClick={() => loadFolderTemplates(record.name)}
            >
              {record.templates_count}
            </Button>
          </Flex>
        </Flex>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      align: "left",
    },
    {
      title: "Action",
      dataIndex: "",
      width: "40%",
      key: "x",
      align: "center",
      render: (key) => (
        <Flex gap="middle" vertical>
          <Flex wrap gap="middle" justify="center">
            <EyeTwoTone onClick={() => loadFolderTemplates(key.name)} />
            <EditTwoTone onClick={() => navigateToUpdate(key.id)} />
            {key.templates_count <= 0 && (
              <DeleteTwoTone
                twoToneColor="#eb2f96"
                onClick={() => handleDelete(key.id)}
              />
            )}
          </Flex>
        </Flex>
      ),
    },
  ];

  const handleDelete = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this folder?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      centered: true,
      keyboard: true,
      maskClosable: true,
      confirmLoading: true,
      onOk: async () => {
        try {
          const { data, error } = await deleteEmailTemplateFolder(record);
          if (data) {
            successMsg(data?.message);
          }
          if (error) {
            console.log("error", error);
            errorMsg(error?.data?.message);
          }
        } catch (error) {
          console.error("Oops errors!", error);
        }
      },
    });
  };

  function loadFolderTemplates(folder_name) {
    navigate(`/${auth}/${user_token}/${viewType}/templates/${folder_name}`);
  }

  useEffect(() => {
    const result = dataList.filter((temp) => {
      return temp?.name.toLowerCase().match(search.toLowerCase());
    });
    setFilterList(result);
  }, [search, dataList]);

  const navigateCreate = () => {
    navigate(`/${auth}/${user_token}/${viewType}/create-folder`);
  };
  return (
    <>
      {loading && <LoadingComponentAntD content={"Loading"} />}
      {contextHolder}
      <Content style={{ padding: "0 48px" }}>
        <div className="container">
          <div className="table-enter-leave-demo-action-bar">
            <Flex gap="middle" vertical>
              <Flex wrap gap="middle" justify="end">
                {moduleName && (
                  <>
                    <Button type="primary" onClick={navigateCreate}>
                      <PlusOutlined />
                      Create
                    </Button>
                  </>
                )}
              </Flex>
            </Flex>
          </div>
          <div className="table-enter-leave-demo-action-bar">
            <Flex gap="middle" vertical>
              <Flex wrap gap="middle" justify="space-between" align="center">
                <h2 className="m-0">Folders</h2>
                {moduleName && (
                  <>
                    <Search
                      placeholder="search by name"
                      onChange={onChange}
                      style={{ width: 300 }}
                    />
                  </>
                )}
              </Flex>
            </Flex>
          </div>

          <Table
            pagination={{
              position: ["none", "bottomCenter"],
              pageSizeOptions: ["10", "20", "25", "30"],
              showSizeChanger: true,
              locale: { items_per_page: "" },
            }}
            loading={loading}
            bordered={true}
            scroll={{
              y: 400,
            }}
            className="custom-table-class"
            virtual={true}
            columns={columns}
            dataSource={filterList}
          />
        </div>
      </Content>
    </>
  );
}

export default AllEmailTemplateFolders;
